import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function VoucherPage() {
  const [activeTab, setActiveTab] = useState<'ai' | 'data'>('ai');

  return (
    <div className="pt-20">
      <section className="py-36 bg-gradient-to-b from-[#0A1F1F] to-[#0D9488]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <span className="text-sm font-medium text-[#5EEAD4] mb-4 block">정부 지원 사업</span>
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-8">
              바우처 사업 수행
            </h1>
            <p className="text-lg text-gray-200 leading-relaxed">
              중소·중견기업의 AI 및 데이터 활용을 지원하는<br />
              정부 바우처 사업 공급기업으로 선정되었습니다.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-[#F0FDFA] rounded-full p-1 border border-[#99F6E4]/30">
              <button
                onClick={() => setActiveTab('ai')}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  activeTab === 'ai'
                    ? 'bg-[#0D9488] text-white'
                    : 'text-[#0F766E] hover:text-[#0D9488]'
                }`}
              >
                AI 바우처
              </button>
              <button
                onClick={() => setActiveTab('data')}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  activeTab === 'data'
                    ? 'bg-[#0D9488] text-white'
                    : 'text-[#0F766E] hover:text-[#0D9488]'
                }`}
              >
                데이터 바우처
              </button>
            </div>
          </div>

          {activeTab === 'ai' && (
            <div className="space-y-20">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">AI 바우처 사업</h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-12">
                  중소·중견기업의 AI 기술 도입을 지원하는 정부 바우처 사업입니다.
                  AI 컨설팅부터 실제 시스템 구축까지 전 과정을 지원합니다.
                </p>

                <div className="grid md:grid-cols-3 gap-8 mb-16">
                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-lightbulb-flash-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">AI 컨설팅</h3>
                    <p className="text-sm text-gray-600">
                      기업 환경 분석 및 AI 도입 전략 수립
                    </p>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-code-box-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">AI 개발</h3>
                    <p className="text-sm text-gray-600">
                      맞춤형 AI 모델 개발 및 시스템 구축
                    </p>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-customer-service-2-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">운영 지원</h3>
                    <p className="text-sm text-gray-600">
                      AI 시스템 운영 및 유지보수 지원
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-10 border border-gray-200">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">수행 범위</h3>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">AI 기술 컨설팅</h4>
                        <p className="text-sm text-gray-600">
                          기업의 비즈니스 환경을 분석하고 최적의 AI 도입 전략을 제시합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">AI 모델 개발</h4>
                        <p className="text-sm text-gray-600">
                          머신러닝, 딥러닝 기반의 맞춤형 AI 모델을 개발합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">시스템 통합</h4>
                        <p className="text-sm text-gray-600">
                          개발된 AI 모델을 기존 시스템에 통합하고 안정적으로 운영합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">교육 및 지원</h4>
                        <p className="text-sm text-gray-600">
                          AI 시스템 활용 교육 및 지속적인 기술 지원을 제공합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-8">적용 사례</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      제조 품질 예측 AI
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                      생산 공정 데이터를 분석하여 제품 불량을 사전에 예측하는 AI 시스템 구축
                    </p>
                    <div className="text-sm text-[#0D9488] font-medium">
                      불량률 30% 감소
                    </div>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      고객 응대 챗봇
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                      자연어처리 기반 고객 문의 자동 응답 시스템 개발
                    </p>
                    <div className="text-sm text-[#0D9488] font-medium">
                      응대 시간 50% 단축
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'data' && (
            <div className="space-y-20">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">데이터 바우처 사업</h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-12">
                  기업의 데이터 활용 역량 강화를 위한 정부 바우처 사업입니다.
                  데이터 수집·가공·분석·활용까지 전문적인 솔루션을 제공합니다.
                </p>

                <div className="grid md:grid-cols-3 gap-8 mb-16">
                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-database-2-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">데이터 수집·가공</h3>
                    <p className="text-sm text-gray-600">
                      다양한 소스에서 데이터 수집 및 정제
                    </p>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-bar-chart-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">데이터 분석</h3>
                    <p className="text-sm text-gray-600">
                      통계 분석 및 인사이트 도출
                    </p>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                      <i className="ri-dashboard-line text-2xl text-[#0D9488]"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">시각화</h3>
                    <p className="text-sm text-gray-600">
                      대시보드 및 리포트 구축
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-10 border border-gray-200">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">수행 범위</h3>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">데이터 컨설팅</h4>
                        <p className="text-sm text-gray-600">
                          기업의 데이터 현황을 진단하고 활용 전략을 수립합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">데이터 수집 및 가공</h4>
                        <p className="text-sm text-gray-600">
                          다양한 소스에서 데이터를 수집하고 분석 가능한 형태로 가공합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">데이터 분석 및 시각화</h4>
                        <p className="text-sm text-gray-600">
                          통계 분석을 통해 인사이트를 도출하고 직관적인 대시보드를 구축합니다.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 mt-1 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#0D9488]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">데이터 플랫폼 구축</h4>
                        <p className="text-sm text-gray-600">
                          지속적인 데이터 활용을 위한 통합 플랫폼을 구축합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-8">적용 사례</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      유통 데이터 통합 플랫폼
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                      온·오프라인 판매 데이터를 통합하고 실시간 분석 대시보드 구축
                    </p>
                    <div className="text-sm text-[#0D9488] font-medium">
                      의사결정 속도 3배 향상
                    </div>
                  </div>

                  <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      제조 공정 데이터 분석
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                      생산 공정 데이터를 수집·분석하여 효율성 개선 포인트 도출
                    </p>
                    <div className="text-sm text-[#0D9488] font-medium">
                      생산 효율 25% 향상
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mt-20 text-center">
            <div className="bg-gradient-to-br from-[#0A1F1F] to-[#0D9488] rounded-lg p-12">
              <h3 className="text-3xl font-bold text-white mb-4">
                바우처 사업 신청을 고민 중이신가요?
              </h3>
              <p className="text-lg text-gray-200 mb-8">
                전문가와 상담하고 최적의 솔루션을 찾아보세요.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-10 h-14 bg-white text-[#0D9488] rounded-full font-medium text-base hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                상담 문의하기
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
